import { Nullable } from '@frontend/sports/common/core/utils/extended-types';

import { PaymentMethod, QuickDepositPage } from './quick-deposit.models';

export interface IQuickDepositState {
    isAvailable: boolean;
    isOpen: boolean;
    isVisible: boolean;
    isProcessing: boolean;
    page: QuickDepositPage;
    height: number;
    deltaY: number;
    selectedpaymentMethod?: PaymentMethod;
    fundsAdded: Nullable<{
        success: boolean;
        depositAmount: number;
    }>;
}

export const defaultQuickDepositState: IQuickDepositState = {
    isAvailable: false,
    isOpen: false,
    isVisible: false,
    isProcessing: false,
    page: QuickDepositPage.Deposit,
    height: 0,
    deltaY: 0,
    fundsAdded: null,
};
